export const PATHS = {
  Teams: '/teams',
  Training: '/training',
  Mission: '/mission',
  Blog: '/blog',
  Saved: '/saved',
  Services: '/services',
  About: '/about',
  OurStory: '/our-story',
  Benefits: '/benefits',
  Careers: '/careers',
  Help: '/help',
  FAQ: '/faq',
  ContactUs: '/contact-us',
  Settings: '/settings',
  Advertise: '/advertise',
  Gear: '/gear',
  Login: '/login',
  SignUp: '/sign-up',
  Onboarding: '/onboarding',
  Search: '/search',
} as const;

export enum FULL_SCREEN_PATHS {
  Onboarding = '/onboarding',
  Admin = '/admin',
}

export const isOnFullScreenPath = (pathname: string, otherPaths?: string[]) => {
  return [...Object.values(FULL_SCREEN_PATHS), ...(otherPaths || [])].some(
    (path) => pathname.includes(path)
  );
};

export const Setting = {
  Profile: '/profile',
  Athlete: '/athlete',
  AthleteGeneral: '/general',
  AthleteHandedness: '/handedness',
  AthletePosition: '/position',
  AthleteTeamNotifications: '/team-notifications',
  Team: '/team',
  TeamDetails: '/general',
  TeamStaff: '/staff',
  TeamBulletinBoard: '/posts',
  TeamBadges: '/badges',
  TeamLocation: '/location',
  TeamFacilities: '/facilities',
  TeamInfo: '/info',
  TeamAgeGroups: '/age-groups',
  TeamRequests: '/team-requests',
  TeamSocialMedia: '/social-media',
} as const;
